import { useActiveSessionsStore } from '../stores/activeSessionsStore';

/**
 * Keeps REST hydration disabled until the optimistic conversation row has been
 * reconciled with the global API list.
 *
 * The pending-conversation store is the lifecycle authority. Mirroring it in
 * component state creates two writers: the phantom lifecycle and the WebSocket
 * streaming lifecycle can then alternately set and clear the same id on every
 * render, which previously produced an unbounded feedback-fetch loop.
 */
export function usePendingConversationSkipId(
  conversationId: string | null,
): string | null {
  return useActiveSessionsStore((state) => (
    conversationId && state.pendingConversations[conversationId]
      ? conversationId
      : null
  ));
}
